import { useState } from "react";

type Item = {
  tag: string;
  title: string;
  desc: string;
  views: string;
  likes: string;
  dur: string;
  img: string;
};

const CATS = ["全部", "街头搭讪", "地铁偶遇", "咖啡店", "相亲局", "酒局", "网络奔现"];

const ITEMS: Item[] = [
  {
    tag: "街头搭讪",
    title: "开口三秒被一眼看穿：小姐姐笑着问“你练过吧”",
    desc: "搭讪话术背得滚瓜烂熟，可惜对方一句话就让他当场破防，围观群众笑得直拍大腿。",
    views: "128.6w",
    likes: "3.2w",
    dur: "00:58",
    img: "https://readdy.ai/api/search-image?query=funny%20flat%20cartoon%20illustration%20of%20an%20embarrassed%20young%20man%20holding%20a%20single%20red%20flower%20being%20politely%20rejected%20on%20a%20sunny%20city%20street%2C%20a%20girl%20giggling%20and%20waving%20goodbye%2C%20other%20people%20laughing%20around%2C%20vibrant%20warm%20orange%20and%20cream%20color%20palette%20with%20teal%20accents%2C%20humorous%20comic%20book%20style%2C%20clean%20flat%20vector%20shapes%2C%20cheerful%20light%20mood&width=800&height=450&seq=feed-card-01&orientation=landscape"
  },
  {
    tag: "地铁偶遇",
    title: "地铁上那句“你好漂亮”后，空气安静了十几站",
    desc: "本以为甜甜的爱情要来了，结果对方全程低头刷手机，唯一的回应是报站广播。",
    views: "96.3w",
    likes: "2.1w",
    dur: "01:32",
    img: "https://readdy.ai/api/search-image?query=humorous%20flat%20cartoon%20illustration%20of%20an%20awkward%20silence%20between%20a%20nervous%20young%20man%20and%20a%20girl%20with%20headphones%20inside%20a%20subway%20train%2C%20empty%20cabin%2C%20passengers%20quietly%20watching%2C%20awkward%20atmosphere%2C%20vibrant%20orange%20teal%20and%20cream%20flat%20vector%20illustration%20style%2C%20funny%20comic%20scene%2C%20bright%20and%20cheerful%20lighting&width=800&height=450&seq=feed-card-02&orientation=landscape"
  },
  {
    tag: "咖啡店",
    title: "咖啡店直球：加微信失败，连店员都看不下去了",
    desc: "把对方夸成艺术品，结果人家一句“我有对象了”，他手里的拿铁比表情还苦。",
    views: "210.4w",
    likes: "5.6w",
    dur: "02:07",
    img: "https://readdy.ai/api/search-image?query=cute%20flat%20cartoon%20illustration%20of%20a%20disappointed%20young%20man%20at%20a%20coffee%20counter%20being%20gently%20refused%20while%20ordering%2C%20coffee%20shop%20barista%20and%20girl%20customer%20smiling%20awkwardly%2C%20cozy%20warm%20interior%2C%20vibrant%20orange%20amber%20and%20cream%20flat%20vector%20illustration%2C%20playful%20humorous%20comic%20scene%2C%20soft%20teal%20accents%2C%20cheerful%20mood&width=800&height=450&seq=feed-card-03&orientation=landscape"
  },
  {
    tag: "相亲局",
    title: "相亲局社死现场：开场白把对方名字都念错了",
    desc: "想着幽默开场活跃气氛，结果一紧张把对方名字喊成全名，空气瞬间凝固到结冰。",
    views: "88.9w",
    likes: "1.8w",
    dur: "01:45",
    img: "https://readdy.ai/api/search-image?query=funny%20flat%20cartoon%20illustration%20of%20a%20blind%20date%20table%20with%20a%20flustered%20young%20man%20covering%20his%20face%20in%20embarrassment%20while%20a%20girl%20looks%20confused%2C%20restaurant%20background%20with%20candles%2C%20warm%20orange%20and%20rose%20tones%20with%20cream%20background%2C%20humorous%20comic%20flat%20vector%20illustration%20style%2C%20playful%20and%20light%20mood&width=800&height=450&seq=feed-card-04&orientation=landscape"
  },
  {
    tag: "酒局",
    title: "壮胆三杯后对暗恋对象说“我要追你”，现场炸锅",
    desc: "一哥们借着酒劲跟暗恋对象表白，结果对方正是同桌甲方，全场安静了三秒。",
    views: "156.1w",
    likes: "4.0w",
    dur: "02:22",
    img: "https://readdy.ai/api/search-image?query=energetic%20flat%20cartoon%20illustration%20of%20a%20tipsy%20young%20man%20boldly%20raising%20a%20glass%20to%20confess%20at%20a%20social%20dinner%20table%20with%20friends%20in%20shock%2C%20funny%20surprised%20faces%2C%20warm%20orange%20amber%20and%20teal%20flat%20vector%20illustration%20style%2C%20playful%20comic%20scene%2C%20bright%20celebratory%20lighting%2C%20vibrant%20and%20humorous%20mood&width=800&height=450&seq=feed-card-05&orientation=landscape"
  },
  {
    tag: "网络奔现",
    title: "网聊三个月奔现，见面第一句话两人都沉默了",
    desc: "滤镜下聊得火热，真人见面的一瞬间，双方都开始疯狂回忆这是不是本人。",
    views: "243.8w",
    likes: "7.9w",
    dur: "03:10",
    img: "https://readdy.ai/api/search-image?query=amusing%20flat%20cartoon%20illustration%20of%20two%20people%20meeting%20in%20person%20for%20the%20first%20time%20at%20a%20train%20station%2C%20both%20looking%20awkwardly%20surprised%20with%20question%20marks%20above%20their%20heads%2C%20suitcases%2C%20vibrant%20orange%20and%20teal%20flat%20vector%20illustration%20style%2C%20funny%20comic%20scene%2C%20warm%20sunlight%2C%20cheerful%20and%20playful%20mood&width=800&height=450&seq=feed-card-06&orientation=landscape"
  },
  {
    tag: "街头搭讪",
    title: "土味情话连环轰炸，小姐姐战术性后退三步",
    desc: "从“你笑起来真好看”一路念到“我的心门为你开”，对方当场表演了一出大撤退。",
    views: "72.4w",
    likes: "1.5w",
    dur: "01:18",
    img: "https://readdy.ai/api/search-image?query=silly%20flat%20cartoon%20illustration%20of%20a%20young%20man%20delivering%20cheesy%20pickup%20lines%20with%20floating%20heart%20bubbles%20while%20a%20girl%20steps%20backward%20with%20a%20shocked%20face%2C%20urban%20park%20background%2C%20vibrant%20warm%20orange%20and%20cream%20flat%20vector%20illustration%20style%2C%20humorous%20comic%20scene%2C%20playful%20and%20light%20atmosphere&width=800&height=450&seq=feed-card-07&orientation=landscape"
  },
  {
    tag: "相亲局",
    title: "被追问“有房有车吗”后的教科书级答非所问",
    desc: "面对灵魂拷问，他先是绕地球三圈，最后蹦出一句“我家猫挺可爱的”，全员沉默。",
    views: "134.5w",
    likes: "3.6w",
    dur: "02:41",
    img: "https://readdy.ai/api/search-image?query=comic%20flat%20cartoon%20illustration%20of%20an%20uncomfortable%20young%20man%20scratching%20his%20head%20at%20a%20dinner%20date%20being%20asked%20difficult%20questions%20by%20a%20serious%20girl%20across%20the%20table%2C%20sweat%20drop%20on%20his%20forehead%2C%20warm%20orange%20and%20rose%20palette%20with%20cream%20background%2C%20funny%20humorous%20flat%20vector%20illustration%20style%2C%20playful%20mood&width=800&height=450&seq=feed-card-08&orientation=landscape"
  },
];

export default function Feed() {
  const [cat, setCat] = useState("全部");
  const list = cat === "全部" ? ITEMS : ITEMS.filter((i) => i.tag === cat);

  return (
    <section id="feed" className="bg-orange-50/60 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex flex-col gap-4 md:mb-10 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-2 inline-flex items-center gap-2 rounded-full bg-orange-500 px-3 py-1 text-xs font-semibold text-white">
              <i className="ri-video-fill" /> 新鲜出炉
            </p>
            <h2 className="font-hand text-3xl text-stone-900 md:text-4xl">搭讪翻车现场精选</h2>
            <p className="mt-2 max-w-xl text-sm text-stone-500 md:text-base">
              每一条都经过吃瓜群众鉴定，翻车指数五颗星，观看请备好纸巾与爆米花。
            </p>
          </div>
          <div className="no-scrollbar flex items-center gap-2 overflow-x-auto md:justify-end">
            {CATS.map((c) => (
              <button
                key={c}
                onClick={() => setCat(c)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  cat === c
                    ? "bg-stone-900 text-white"
                    : "border border-stone-300 bg-white text-stone-600 hover:border-orange-400 hover:text-orange-600"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((it) => (
            <article
              key={it.title}
              className="group overflow-hidden rounded-2xl border border-stone-200 bg-white transition-shadow hover:shadow-md"
            >
              <div className="relative aspect-video w-full overflow-hidden">
                <img
                  src={it.img}
                  alt={it.title}
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-orange-500 px-2.5 py-1 text-[11px] font-semibold text-white">
                  {it.tag}
                </span>
                <span className="absolute bottom-3 right-3 rounded bg-black/60 px-2 py-0.5 text-[11px] text-white">
                  {it.dur}
                </span>
                <span className="absolute inset-0 grid place-items-center bg-black/20 opacity-0 transition-opacity group-hover:opacity-100">
                  <span className="grid h-12 w-12 place-items-center rounded-full bg-white/90 text-orange-500">
                    <i className="ri-play-fill text-xl" />
                  </span>
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="line-clamp-2 min-h-[44px] text-sm font-semibold leading-snug text-stone-900 md:text-[15px]">
                  {it.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-stone-500">{it.desc}</p>
                <div className="mt-4 flex items-center justify-between text-xs text-stone-400">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-play-circle-line" /> {it.views}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-thumb-up-line" /> {it.likes}
                  </span>
                  <button className="inline-flex items-center gap-1 text-orange-500 transition-colors hover:text-orange-600">
                    <i className="ri-bookmark-line" /> 收藏
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-9 text-center">
          <button className="whitespace-nowrap rounded-full border border-orange-300 bg-white px-7 py-3 text-sm font-semibold text-orange-600 transition-colors hover:bg-orange-50">
            加载更多翻车名场面 <i className="ri-arrow-down-line ml-1" />
          </button>
        </div>
      </div>
    </section>
  );
}